import React from 'react';
import CustomerTable from 'src/pages/StoreVoucher/Detail/Components/CustomerTable';
import css from './css.module.less';
// import { useParams } from 'react-router-dom';
// import { getTagsInSalesChannel } from 'src/request/customer';
import { ItemWrapper } from '@/src/components';
import SectionWrapper from '@/src/pages/SalesCannelVersion/Components/SectionWrapper';
import { Spin } from 'antd';
import { get, isEqual } from 'lodash';
import {
  Button,
  Form,
  OriCheckbox,
  OriSelect,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import { getDbRelated, getEligibleCustomers } from 'src/request/voucher';
import { generalFilterOptions, isNumber } from 'src/tools/helper';
import { replaceI18nVariables } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
export enum ECondition {
  Registered = 'Registered',
  Specific = 'Specific',
}
const _base = 'customerCondition';
const radioName = [_base, 'conditionType'];
const customerName = [_base, 'customers'];
const tagsName = [_base, 'customerTags'];
const _excludeVouchers = [_base, 'excludeVouchers'];
const _vouchers = [_base, 'vouchers'];

const CustomerEligibleCondition = (props) => {
  //const { uuid }: any = useParams();
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [loaded, setLoaded] = React.useState(false);
  const { form, currentDb, disabled, uuid } = props;
  const [tags, setTags] = React.useState([]);
  const [allVouchers, setAllVouchers] = React.useState([]);
  const [eligibleCustomer, setEligibleCustomer] = React.useState(null);
  const isEcNumber = isNumber(eligibleCustomer);
  //console.log('tags', tags);

  React.useEffect(() => {
    if (currentDb) {
      setLoaded(false);
      getDbRelated(
        { firstRow: 0, countPerPage: 999 },
        { params: { customerDatabaseUuid: currentDb } },
      ).then((res) => {
        const { customerTags, vouchers } = res;
        setTags(customerTags || []);
        setAllVouchers(vouchers || []);
        setLoaded(true);
      });
    } else {
      setTags([]);
      setAllVouchers([]);
      // setLoaded(true);
    }
  }, [currentDb]);
  //console.log('currentDb', currentDb);

  return (
    <SectionWrapper title={getI18n('voucher.storeVoucherDetail.voucherSendTo')}>
      <Item
        noStyle
        shouldUpdate={(p, c) => {
          const pV = get(p, 'customerDatabase');
          const cV = get(c, 'customerDatabase');
          return pV != cV;
        }}>
        {({ getFieldValue }) => {
          const dbUuid = getFieldValue('customerDatabase');
          if (dbUuid) {
            return (
              <Spin spinning={!loaded}>
                <Section bottomBorder className={css.section}>
                  <Item
                    name={radioName}
                    rules={[
                      {
                        required: true,
                        message: getI18n('general.pleaseselectavalue'),
                      },
                    ]}>
                    <RadioGroup className={css.radioGroup} disabled={disabled}>
                      <RadioItem
                        className={css.radio}
                        value={ECondition.Registered}>
                        {getI18n(
                          'voucher.storeVoucherDetail.registeredcustomers',
                        )}
                      </RadioItem>
                      <RadioItem
                        value={ECondition.Specific}
                        className={css.radioLast}>
                        {getI18n(
                          'voucher.storeVoucherDetail.customertagspecificcustomers',
                        )}
                      </RadioItem>
                    </RadioGroup>
                  </Item>
                  <Item
                    shouldUpdate={(p, c) => {
                      const pV = get(p, radioName);
                      const cV = get(c, radioName);
                      return pV !== cV;
                    }}>
                    {({ getFieldValue }) => {
                      const dbUuid = getFieldValue('customerDatabase');
                      const isDisplay =
                        getFieldValue(radioName) === ECondition.Specific;
                      if (isDisplay) {
                        return (
                          <div className={css.customerSelectionContainer}>
                            <Item
                              shouldUpdate={(p, c) => {
                                const pV = get(p, tagsName);
                                const cV = get(c, tagsName);
                                const pC = get(p, customerName);
                                const cC = get(c, customerName);
                                const pD = get(p, 'customerDatabase');
                                const cd = get(c, 'customerDatabase');
                                return pV !== cV || pC !== cC || pD !== cd;
                              }}>
                              {({ getFieldValue }) => {
                                const customers =
                                  getFieldValue(customerName) || [];
                                //const _tags = getFieldValue(tagsName) || [];
                                if (
                                  form.isFieldTouched(tagsName) ||
                                  form.isFieldTouched(customerName)
                                )
                                  setTimeout(() => {
                                    form.validateFields([tagsName]);
                                  });
                                return (
                                  <Item
                                    name={tagsName}
                                    rules={[
                                      {
                                        validator: async (x, value) => {
                                          if (
                                            customers.length === 0 &&
                                            (value || []).length === 0
                                          ) {
                                            return Promise.reject(
                                              new Error(
                                                getI18n(
                                                  'voucher.storeVoucherDetail.selectonetagorcustomer',
                                                ),
                                              ),
                                            );
                                          }
                                        },
                                      },
                                    ]}>
                                    <_Tags tags={tags} disabled={disabled} />
                                  </Item>
                                );
                              }}
                            </Item>
                            <div className={css.tableContainer}>
                              <div className={css.tableTitle}>
                                {getI18n(
                                  'voucher.storeVoucherDetail.specificcustomers',
                                )}
                              </div>
                              <Item name={customerName}>
                                <CustomerTable
                                  disabled={disabled}
                                  tableId={'StoreVoucherCustomerTable'}
                                  dbUuid={dbUuid}
                                  tags={tags}
                                />
                              </Item>
                            </div>
                          </div>
                        );
                      }
                      return null;
                    }}
                  </Item>
                </Section>
                <Section bottomBorder className={css.voucherSection}>
                  <Item
                    valuePropName={'checked'}
                    name={_excludeVouchers}
                    className={css.excludeCheckbox}>
                    <OriCheckbox disabled={disabled}>
                      {getI18n(
                        'voucher.storeVoucherDetail.excludecustomersreceived',
                      )}
                    </OriCheckbox>
                  </Item>
                  <Item
                    shouldUpdate={(p, c) => {
                      const pV = get(p, _excludeVouchers);
                      const cV = get(c, _excludeVouchers);
                      return cV !== pV;
                    }}>
                    {({ getFieldValue }) => {
                      const display = getFieldValue(_excludeVouchers);
                      if (display) {
                        return (
                          <div className={css.container}>
                            <Item
                              name={_vouchers}
                              rules={[
                                {
                                  required: true,
                                  message: getI18n(
                                    'voucher.storeVoucherDetail.selectonvoucher',
                                  ),
                                },
                              ]}>
                              <OriSelect
                                size='large'
                                mode='multiple'
                                showSearch
                                placeholder={replaceI18nVariables(
                                  getI18n('general.selectAndSearchPlaceholder'),
                                  getI18n('general.sider.voucher'),
                                )}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                disabled={disabled}>
                                {allVouchers.map((i) => {
                                  const { name, uuid } = i;
                                  return (
                                    <OriSelect.Option value={uuid} key={uuid}>
                                      {name}
                                    </OriSelect.Option>
                                  );
                                })}
                              </OriSelect>
                            </Item>
                          </div>
                        );
                      }
                      return null;
                    }}
                  </Item>
                </Section>
                <Section bottomBorder className={css.voucherSection}>
                  <ItemWrapper
                    title={getI18n(
                      'voucher.storeVoucherDetail.currentEligibleCustomerNumber',
                    )}>
                    {isEcNumber ? eligibleCustomer.toString() : '-'}
                  </ItemWrapper>
                  <Button
                    disabled={disabled}
                    type='primary'
                    onClick={() => {
                      form.validateFields(['voucherType']).then((res) => {
                        const data = form.getFieldValue(_base);
                        const voucherType = form.getFieldValue('voucherType');
                        const voucherQuantity =
                          form.getFieldValue('voucherQuantity');
                        //voucherQuantity
                        //console.log('voucherQuantity', voucherQuantity);
                        const { customers, vouchers } = data;
                        // const _customerTags = (customerTags || []).map((i) => ({
                        //   uuid: i,
                        // }));
                        // const _customers = (customers || []).map((i) => ({
                        //   uuid: i,
                        // }));
                        const _vouchers = (vouchers || []).map((i) => ({
                          uuid: i,
                        }));
                        const obj = {
                          customerDatabase: {
                            uuid: currentDb,
                          },
                          voucherQuantity,
                          uuid,
                          //
                          voucherType,
                          customerCondition: {
                            ...data,
                            vouchers: _vouchers,
                            // customerTags: _customerTags,
                            customers,
                          },
                        };
                        getEligibleCustomers(obj).then((res) => {
                          setEligibleCustomer(res);
                        });
                      });
                    }}>
                    {getI18n('voucher.storeVoucherDetail.calculate')}
                  </Button>
                </Section>
              </Spin>
            );
          }

          return (
            <div className={css.noDatabase}>
              {getI18n(
                'voucher.storeVoucherDetail.selectcustomerdatabasefirst',
              )}
            </div>
          );
        }}
      </Item>
    </SectionWrapper>
  );
};
export default CustomerEligibleCondition;
const _Tags = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange, id, tags, disabled } = props;
  const _value = React.useMemo(() => {
    return (value || []).map((i) => {
      return (i || {}).uuid;
    });
  }, [value]);
  const [data, setData] = React.useState(_value);
  //
  // console.log('tags', tags);
  React.useEffect(() => {
    if (!isEqual(_value, data)) {
      setData(_value);
    }
  }, [_value]);
  // console.log('_value', _value);
  //
  const handleOnChange = (e) => {
    //  console.log('e', e);
    const re = e.map((i) => ({ uuid: i }));
    //
    onChange(re);
  };
  return (
    <OriSelect
      disabled={disabled}
      id={id}
      size='large'
      mode='multiple'
      value={data}
      onChange={(e) => {
        setData(e);
        handleOnChange(e);
      }}
      showSearch
      placeholder={replaceI18nVariables(
        getI18n('general.selectAndSearchPlaceholder'),
        getI18n('general.sider.voucher'),
      )}
      filterOption={generalFilterOptions}>
      {(tags || []).map((i) => {
        const { uuid, name } = i;
        return (
          <OriSelect.Option value={uuid} key={uuid}>
            {name}
          </OriSelect.Option>
        );
      })}
    </OriSelect>
  );
};
